import { UnitCode } from 'lib/graphql/storeadmin'
import moment from 'moment'

// Products Constants is using in multiple files
export const productsDefaultVariation = [
  {
    key: '0',
    price: 0,
    specialPrice: 0,
    unit: UnitCode.PerDay,
    inventory: 0,
    availableForSale: true,
    periodForSale: {
      id: '1',
      start: moment(),
      end: moment().add(1, 'M'),
    },
  },
]

export const productsDefaultOptions = [
  {
    options: '',
    productOptionsValues: [{ optionsValue: '' }],
  },
]
